import React from 'react';
import Header from '../common/Header';
import Hero from '../common/Hero';
import Menu from '../common/Menu';
import Testimonials from '../common/Testimonials';
import Contact from '../common/Contact';
import Footer from '../common/Footer';
import ScrollManager from '../layout/scrollManager';
import SideContactBar from '../layout/SideContactBar';

import { LanguageProvider } from '../../context/LanguageContext';

const Home = () => {
  return (
    <ScrollManager>
      <LanguageProvider>
        <div className="flex flex-col min-h-screen font-sans">
          <Header />
          {/* <Navigation /> */}
          {/* <SideContactBar /> */}
          <main>
            <section id="home" className="scroll-snap-section">
              <Hero />
            </section>
            <section id="services" className="scroll-snap-section">
              <Menu />
            </section>
            <section id="testimonials" className="scroll-snap-section">
              <Testimonials />
            </section>
            <section id="contact" className="scroll-snap-section">
              <Contact />
            </section>
          </main>
          <Footer />
        </div>
      </LanguageProvider>
    </ScrollManager>
  );
};

export default Home;